/*
 * @Author: changcheng
 * @LastEditTime: 2023-12-08 09:41:31
 */
import {
  Tree,
  Modal,
  Form,
  Input,
  Select,
  Button,
  Space,
  message,
  Popconfirm,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  querySpecialClassificationDataByLive,
  queryCategoryDataByTreeId,
  queryCategoryParentListByLive,
  querySaveCategoryDataByLive,
  queryDeleteLiveCategoryById,
} from "@root/common/service";
import type { TreeProps } from "antd/es/tree";
import "./_index.scss";
import { Key } from "rc-tree/lib/interface";
const { Option } = Select;
export default function LiveCategory() {
  const [form] = Form.useForm();
  const [treeData, setTreeData] = useState([]);
  const [showSpecialModal, setShowSpecialModal] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [isAddFlag, setIsAddFlag] = useState(true);
  /**当前的treeId */
  let currentTreeId: Key | null = null;
  /**
   * 获取专项分类数据
   */
  const getSpecialClassificationData = async () => {
    const { data = [] } = await querySpecialClassificationDataByLive();
    setTreeData(data);
  };
  /**
   * 根据专项分类得到专项信息
   * @param treeId
   */
  const getCategoryDataByTreeId = async (treeId: number) => {
    if (!treeId) return;
    const { data } = await queryCategoryDataByTreeId(treeId);
    form.setFieldsValue(data);
  };
  /**
   * 得到专项分类列表
   */
  const getCategoryParentList = async () => {
    const { data = [] } = await queryCategoryParentListByLive();
    console.log("setCategoryList", data);

    setCategoryList(data);
  };
  const onSelect: TreeProps["onSelect"] = (selectedKeys, info) => {
    setShowSpecialModal(true);
    const treeId = selectedKeys[0];

    getCategoryDataByTreeId(treeId as number);
    getCategoryParentList();
    setIsAddFlag(false);
  };
  const onCheck = (checkedKeys: any) => {
    currentTreeId = checkedKeys[0];
  };

  /**
   * 新增专项分类
   * @param value 表单值
   */
  const saveCategoryData = async (values: any) => {
    await querySaveCategoryDataByLive(values);
    message.success(`${isAddFlag ? "新增" : "修改"}分类成功`);
    setShowSpecialModal(false);
    getSpecialClassificationData();
  };
  const onFinish = (values: any) => {
    saveCategoryData(values);
  };
  useEffect(() => {
    getSpecialClassificationData();
  }, []);
  return (
    <div className="categoryContainer">
      <Space>
        <Button
          type="primary"
          onClick={() => {
            setShowSpecialModal(true);
            getCategoryParentList();
            setIsAddFlag(true);
          }}
        >
          新增分类
        </Button>
        <Popconfirm
          title="是否要删除？"
          onConfirm={async () => {
            if (currentTreeId) {
              await queryDeleteLiveCategoryById(currentTreeId as number);
              message.success("删除成功");
              await getSpecialClassificationData();
            } else {
              message.info("请选择分类");
            }
          }}
          okText="Yes"
          cancelText="No"
        >
          <Button>删除</Button>
        </Popconfirm>
      </Space>
      <div className="tree_container">
        <Tree
          checkable
          onSelect={onSelect}
          treeData={treeData}
          onCheck={onCheck}
        />
      </div>
      <Modal
        visible={showSpecialModal}
        title={`${isAddFlag ? "新增" : "编辑"}分类`}
        footer={null}
        onCancel={(e) => {
          setShowSpecialModal(false);
        }}
        destroyOnClose={true}
      >
        <Form
          style={{
            width: "300px",
          }}
          form={form}
          onFinish={onFinish}
          preserve={false}
        >
          <Form.Item label="分类内容" name="name">
            <Input maxLength={20} />
          </Form.Item>
          <Form.Item label="分类节点" name="parentId">
            <Select>
              {categoryList.map((item: { id: number; name: string }) => (
                <Option value={item.id}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="排序" name="showOrder">
            <Input type="number" max={9999999999} />
          </Form.Item>
          {/* <Form.Item name="id">
              <Input type="number" hidden max={99} min={0} />
            </Form.Item> */}
          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                保存
              </Button>
              <Button
                onClick={() => {
                  setShowSpecialModal(false);
                }}
              >
                取消
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
